import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { useAtomValue } from 'jotai';
import { Tooltip } from 'flowbite-react';

import { useAuth } from '@restworld/feature-authentication';
import { Button as ButtonV2 } from '@restworld/ui-ds-base';

import SpontaneousApplication from '../spontaneous-application';
import { restaurantDetailsAtom } from '.';
import { hasUserAppliedSpontaneousApplicationAtom } from '../worker-entry-point';
import WorkerEntryPointModal from '../worker-entry-point/worker-entry-point-modal';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IVenueCTAProps {}

const VenueStickyCTA: React.FunctionComponent<IVenueCTAProps> = (props) => {
  const { t } = useTranslation('restaurant-showcase-v2');
  const restaurantDetails = useAtomValue(restaurantDetailsAtom);
  const didUserSpontaneousApply = useAtomValue(hasUserAppliedSpontaneousApplicationAtom);
  const { user } = useAuth();

  const btn = ({ disabled }: { disabled?: boolean }) => (
    <SpontaneousApplication
      restaurantID={restaurantDetails?.restaurantId}
      label={didUserSpontaneousApply ? t('show_application_status') : t('send_spontaneous_application')}
      fullwidth
      tooltipTitle={
        user?.type === 'worker' || !user ? undefined : t('here_is_how_candidates_see_showcase_as_a_public_venue')
      }
    >
      <ButtonV2 disabled={disabled} fullwidth>
        {didUserSpontaneousApply ? t('show_application') : t('send_spontaneous_application')}
      </ButtonV2>
    </SpontaneousApplication>
  );
  return (
    <>
      <div className="w-full py-4 left-0 bottom-0 fixed bg-neutral-10 shadow-[0px_-4px_16px_0px_rgba(0,0,26,0.25)] border-t border-neutral-40 inline-flex flex-col justify-start items-center gap-2.5">
        <div className="w-full px-4 max-w-[640px] mx-auto flex flex-col justify-center items-center gap-2.5">
          {user?.type === 'worker' || !user ? btn({ disabled: false }) : btn({ disabled: true })}
        </div>
      </div>
      <WorkerEntryPointModal />
    </>
  );
};

export default VenueStickyCTA;
